export default "__VITE_ASSET__DatpazwS__"